
import React from "react";
import { Routes, Route } from 'react-router-dom';
import Col from "react-bootstrap/Col";
import Projects from "./content/project/Projects";
import SystemTypes from "./content/system_types/SystemTypes";
import Contact from "./content/contact/contact";
import Environments from "./content/model/Environments";
import About from "./content/about/about";
import HomeContent from "./content/home/home";


function Content(){
    return (
        <Col md={9} lg={10}>
            <Routes>
                <Route path="/" element={<HomeContent />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/system-types" element={<SystemTypes />} />
                <Route path="/environments" element={<Environments />} />
            </Routes>
        </Col>
    );
}

export default Content